import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

/** Dati non arrivati dal server: messaggio + Riprova, al posto di un falso stato vuoto. */
@Component({
  selector: 'app-load-error',
  imports: [TranslatePipe],
  template: `
    <div class="load-error" role="alert">
      <p>{{ message || ('common.load_failed' | translate) }}</p>
      <button type="button" class="btn-gold" (click)="retry.emit()">
        {{ 'common.retry' | translate }}
      </button>
    </div>
  `,
  styles: `
    .load-error {
      background: var(--surface);
      border: 1.5px solid var(--border);
      border-radius: 14px;
      padding: 1.5rem;
      text-align: center;
      margin: 1rem 0;
    }
    .load-error p {
      font-size: 0.95rem;
      color: var(--text-mid);
      margin: 0 0 1rem;
    }
  `,
})
export class LoadErrorComponent {
  @Input() message = '';
  @Output() retry = new EventEmitter<void>();
}
